/* eslint-disable no-alert */
/* eslint-disable func-style */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-prototype-builtins */

((window, document) => {
  // Get the reference to the order details
  const orderDetail = window.orderDetails ? window.orderDetails.orderDetail : null;
  // const stockRef = window.stockRef ? window.stockRef : null;

  // Postcode regex
  const POSTCODE_REGX =
    /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;

  // Get elements to show when the delivery price has been calulated from the VDP
  const calulatedDeliveryElementsToShow = document.querySelectorAll(
    '.js-show-when-calculated-delivery',
  );

  const CHECKOUT_KEY = '_soform';
  const IS_BARCLAYS_CHECKOUT_AND_ECOMM = '_isBarclaysCheckoutAndEcomm';

  // Store the postcode look up response addresses
  let postcodeLookupResponse = [];

  const AJAX_MBS_URL = '/content/api/ajax_mbs_search.p';

  const sessionCheck = () => {
    window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
      .then((res) => {
        const data = res.myData;
        if (data.myResultData[0].sessionSts === 'SECURE') {
          window.Cookie.get('mcSess').split('-');
        } else {
          // eslint-disable-next-line no-unused-expressions
          [null, null];
        }
      })
      .catch((err) => {
        window.vm.debug.error(err);
      });
  };

  sessionCheck();

  const extendSessionExpiry = () => {
    window.SessionCheck.checkSession(AJAX_MBS_URL, 'extend')
      .then(() => {})
      .catch((err) => {
        window.vm.debug.error(err);
      });
  };

  /**
   * Get the checkout elements from the page in order to bind values to them
   * and handle hide/show manipulation
   */
  const getCheckoutElements = () => ({
    spinner: document.querySelector('.js-spinner') || false,

    // Form elements
    postcode: document.querySelector('input[name=postcode]'),
    addressDropdown: document.querySelector('select[name=deliveryDropdown]'),
    address1: document.querySelector('input[name=deliveryAddr1]'),
    address2: document.querySelector('input[name=deliveryAddr2]'),
    town: document.querySelector('input[name=deliveryAddr3]'),
    county: document.querySelector('input[name=deliveryAddr4]'),
    telephone: document.querySelector('input[name=telephone]'),

    // Containers
    customerDetails: document.querySelector('.js-customer-details'), // Address details container
    customerAddress: document.querySelector('.js-customer-address'), // Customer stored address container
    customerPostcode: document.querySelector('.js-customer-postcode'), // Customer postcode container
    customerAddressForm: document.querySelector('.js-customer-address-form'), // Customer address form inputs container
    customerContact: document.querySelector('.js-customer-contact'), // Customer contact details container
    customerNumber: document.querySelector('.js-customer-number'), // Customer stored contact number
    customerTelephone: document.querySelector('.js-customer-telephone'), // Customer telephone form input container
    continueToPayment: document.querySelector('.js-continue-to-payment'),

    // Buttons
    editAddressButton: document.querySelector('.js-customer-details button'),
    findPostcodeButton: document.querySelector('.js-customer-postcode button'),
    editNumberButton: document.querySelector('.js-customer-contact button'),
    refreshPageButton: document.querySelector('.js-ecomm-refresh-page-btn'),

    // Iframe
    checkoutIframe: document.querySelector('#js-checkout-iframe'),
    checkoutCCForm: document.querySelector('#formWrapperCreditCard'),

    checkoutContainer: document.querySelector('.js-checkout-container'),
    checkoutErrorContainer: document.querySelector('.js-checkout-error-container'),
  });

  /**
   * Get addresses from a given postcode
   * @param {string} postcode The postcode to get addresses from
   */
  const getAddresses = (postcode) =>
    axios
      .get('/content/api/json_solr.p', {
        params: {
          q: 'postsumm',
          wt: 'jsonB',
          pcode: postcode,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(({ data }) => data);

  /**
   * Get the customer details of based on the quote id
   * @param {string} quoteId The quote's id
   */
  const getCustomerDetails = (quoteId) => {
    if (typeof quoteId === 'string' && quoteId !== '') {
      const URI = `/content/api/ajax_ecomm_services.p?Action=GetCustomerDetails&QuoteId=${quoteId}`;

      return axios.get(URI).then(({ data }) => {
        // Extend customer session

        window.SessionCheck.checkSession(AJAX_MBS_URL, 'check').then((res) => {
          if (res.myData.myResultData[0].sessionSts === 'SECURE') {
            extendSessionExpiry();
          }
        });
        return data;
      });
    }
    return Promise.resolve(null);
  };

  /**
   * Set the customer details
   */
  const setCustomerDetails = (
    quoteId,
    delAdd1,
    delAdd2,
    delAdd3,
    delAdd4,
    delAdd5,
    delPostcode,
    telNumber,
    paymentType,
  ) => {
    const {
      checkoutCCForm,
      checkoutErrorContainer,
      continueToPayment,
      refreshPageButton,
      spinner,
    } = getCheckoutElements();
    spinner.classList.remove('hide__default');

    return axios
      .get('/content/api/ajax_ecomm_services.p', {
        params: {
          Action: 'SetCustomerDetails',
          QuoteId: quoteId,
          custAddress1: delAdd1,
          custAddress2: delAdd2,
          custAddress3: delAdd3,
          custAddress4: delAdd4,
          custAddress5: delAdd5,
          custPostcode: delPostcode,
          custTelephone: telNumber,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(({ data }) => {
        if (paymentType === 'BARCLAYS') {
          const customerDetailsResponse = data?.SetCustomerDetailsResponse;
          const hppCheckoutUrl = customerDetailsResponse?.HppCheckoutUrl;
          const CheckoutErr = customerDetailsResponse?.HppCheckoutErr?.CheckoutErr;

          orderDetail.checkoutId = customerDetailsResponse?.HppCheckoutId;

          const script = document.createElement('script');
          const paymentFormContainer = document.createElement('div');
          paymentFormContainer.id = 'payment_form_container';

          script.src = hppCheckoutUrl;
          script.async = true;

          if (paymentFormContainer && checkoutCCForm) {
            paymentFormContainer.appendChild(script);
            checkoutCCForm.appendChild(paymentFormContainer);
          }

          if (refreshPageButton) {
            refreshPageButton.classList.remove('hide__default');
          }

          if (CheckoutErr) {
            checkoutErrorContainer?.classList.remove('hide__default');
            refreshPageButton?.classList.add('hide__default');
          }
        }

        spinner?.classList.add('hide__default');
        return data;
      })
      .catch((err) => {
        if (continueToPayment) {
          continueToPayment.classList.add('hide__default');
        }

        if (checkoutErrorContainer) {
          checkoutErrorContainer.classList.remove('hide__default');
        }

        window.vm.debug.error(err);
        spinner?.classList.add('hide__default');
      });
  };

  /**
   * Handle the postcode look up when find address is clicked
   */
  const handlePostcodeLookUp = (checkoutElements) => {
    getAddresses(checkoutElements.postcode.value).then((res) => {
      // Set the options of the address dropdown element
      if (res && res.Addresslines) {
        postcodeLookupResponse = res.Addresslines;

        checkoutElements.addressDropdown.innerHTML = `
            <option disabled selected>Select Address</option>
            ${res.Addresslines.map(
              (addr, index) =>
                `<option value="${index}">${addr.Address_1}, ${addr.Address_2}, ${addr.Town}</option>`,
            ).join('')}
          `;
      } else {
        // eslint-disable-next-line no-alert
        alert(
          'There was an error while trying to find your address. Please try again later or contact us from the contact page.',
        );
      }

      checkoutElements.customerAddressForm.classList.remove('hide__default');
    });
  };

  /**
   * Handle the click event on the document
   * @param {MouseEvent} event The mouse event that occured
   */
  const handleClickEvent = (event) => {
    let clickedEl = event.target;

    const checkoutElements = getCheckoutElements();

    while (clickedEl) {
      // If postcode look up was pressed
      if (clickedEl.matches('.js-customer-postcode button')) {
        handlePostcodeLookUp(checkoutElements);
        break;
      }

      // If edit my address was pressed
      if (clickedEl.matches('.js-customer-details button')) {
        checkoutElements.customerDetails.classList.add('hide__default');
        checkoutElements.customerPostcode.classList.remove('hide__default');
        break;
      }

      // If edit my number was pressed
      if (clickedEl.matches('.js-customer-contact button')) {
        checkoutElements.customerContact.classList.add('hide__default');
        checkoutElements.customerTelephone.classList.remove('hide__default');
        break;
      }

      clickedEl = clickedEl.parentElement;
    }
  };

  /**
   * Set the value of an input element
   * @param {HTMLInputElement} inputEl The input element
   * @param {string} value The value to set
   */
  const setInputValue = (inputEl, value = '') => {
    // Check if input el is passed
    if (inputEl) {
      inputEl.value = value;

      // Fire a blur event for the form utilities to update the classes of the inputs
      if ('fireEvent' in inputEl) {
        // IE
        inputEl.fireEvent('onblur');
      } else if (typeof window.Event === 'function') {
        // Modern browsers
        inputEl.dispatchEvent(new Event('blur'));
      } else {
        // Older browsers
        const evObj = document.createEvent('Event');
        evObj.initEvent('blur', true, true);
        inputEl.dispatchEvent(evObj);
      }
    }
  };

  /**
   * Handle the address dropdown change event
   * @param {Event} event The event that occured
   */
  const handleDropdownChangeEvent = (event) => {
    // Get the checkout elements
    const { address1, address2, town, county } = getCheckoutElements();
    try {
      const selectedAddress = postcodeLookupResponse[event.target.value];
      // Update the inputs value
      setInputValue(address1, selectedAddress.Address_1);
      setInputValue(address2, selectedAddress.Address_2);
      setInputValue(town, selectedAddress.Town);
      setInputValue(county, selectedAddress.County);
    } catch (err) {}
  };

  const addValidator = (submitHandler, invalidHandler) => {
    if (window.validator && typeof window.validator.validate === 'function') {
      window.validator.validate('customer-checkout', {
        rules: {
          deliveryAddr1: { required: true },
          deliveryAddr3: { required: true },
          postcode: { required: true, pattern: 'ukpostcode' },
          telephone: { required: true, pattern: 'phoneUK' },
        },
        submitHandler,
        invalidHandler,
      });

      document.addEventListener('click', handleClickEvent);
    }
  };

  /**
   * Submit the order form to get the iframe
   */
  const submitOrderForm = () => {
    const { checkoutIframe, checkoutCCForm, checkoutContainer } = getCheckoutElements();
    const { paymentType } = orderDetail ?? {};

    // Get the finanance params from storage to check the deposit
    // const sessionQuote = sessionStorage.getItem(`financeParams${stockRef}`);
    // const financeParams = JSON.parse(sessionQuote);
    // const hasZeroDeposit = financeParams.dealDeposit === 0;
    // const cashSelected = financeParams.cashSelected === true;
    // const isReserveItNowCheckout = /referrer=RESERVE_IT_NOW/i.test(window.location.search);

    if (paymentType === 'ELAVON') {
      const orderForm = document.querySelector('#OrderForm');

      // Select the order form
      orderForm.submit();
      checkoutIframe.setAttribute(
        'style',
        'min-height: 700px; width: 100%; display: block; height: 100%;',
      );

      // If zero percent event don't submit form
      // if ((hasZeroDeposit && cashSelected) || (!hasZeroDeposit && !cashSelected)) {
      // } else if (isReserveItNowCheckout) {
      //   orderForm.submit();
      //   checkoutIframe.setAttribute('style', 'min-height: 700px;
      //  width: 100%; display: block; height: 100%;');
      // }
    }

    checkoutCCForm.classList.remove('hide__default');
    checkoutContainer.classList.add('hide__default');

    // highlights the current step, as well as highlighting
    // previous steps and ensuring they are checked
    const setNavsHighlighted = () => {
      const checkoutStep = document.querySelector('.js-checkout-step');
      const checkoutPaymentStep = document.querySelector('.js-checkout-payment-step');
      const detailsStep = document.querySelector('.js-details-step');

      if (checkoutStep) {
        checkoutStep.classList.add('is-active');
        checkoutStep.querySelector('.nav-item__step-number').classList.add('hide__default');
        checkoutStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
        // C2D setting session to tell what stage user is on
        sessionStorage.setItem('_user-stage', 'payment-details');
      }
      if (detailsStep) {
        detailsStep.classList.add('is-active');
        detailsStep.querySelector('.nav-item__step-number').classList.add('hide__default');
        detailsStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
      }
      if (checkoutPaymentStep) {
        checkoutPaymentStep.classList.add('is-active');
        // C2D setting session to tell what stage user is on
        sessionStorage.setItem('_user-stage', 'payment');
      }
    };

    // check the nav steps have loaded, if none are present wait
    // 100ms then try again. Once loaded, hihglight the relevant steps
    const checkNavLoad = () => {
      const navs =
        document.querySelector('.js-checkout-step') ||
        document.querySelector('.js-checkout-payment-step') ||
        document.querySelector('.js-details-step');
      if (navs) {
        setNavsHighlighted();
      } else {
        setTimeout(checkNavLoad, 100);
      }
    };

    checkNavLoad();
    vm.afterLoad(() =>
      window.scrollTo(0, window.pageYOffset + checkoutCCForm.getBoundingClientRect().top - 40),
    );
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    // Get the forms details
    const { postcode, address1, address2, town, county, telephone } = getCheckoutElements();

    // Set the customer details
    setCustomerDetails(
      orderDetail.QuoteId,
      address1.value,
      address2.value,
      town.value,
      county.value,
      '',
      postcode.value,
      telephone.value,
      orderDetail.paymentType,
    )
      .then((res) => {
        // Check if the response has an error
        if (typeof res.ProcessError !== 'undefined') {
          throw new Error(res.ProcessError);
        } else if (
          typeof res.SetCustomerDetailsResponse !== 'undefined' &&
          res.SetCustomerDetailsResponse.hasOwnProperty('statusCode') &&
          res.SetCustomerDetailsResponse.hasOwnProperty('statusDescription')
        ) {
          const { statusCode, statusDescription } = res.SetCustomerDetailsResponse;

          // Check if we have a status code of 70
          if (statusCode === '70') {
            throw new Error(statusDescription);
          }

          // Extend the customer session timeout
          window.SessionCheck.checkSession(AJAX_MBS_URL, 'check').then((res) => {
            if (res.myData.myResultData[0].sessionSts === 'SECURE') {
              extendSessionExpiry();
            }
          });

          // If status code is 32 the customer didnt update their details
          if (statusCode === '32') {
            // Submit the orderForm
            submitOrderForm();
          }

          // If status code is 39 the customer updated their details
          if (statusCode === '39') {
            // Set a session key and submit the order form
            window.sessionStorage.setItem(CHECKOUT_KEY, 'true');
            window.sessionStorage.setItem(IS_BARCLAYS_CHECKOUT_AND_ECOMM, 'true');
            submitOrderForm();
          }
        } else {
          // No setCustomerDetailsResponse was retrieved
          throw new Error(JSON.stringify(res));
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  };

  /**
   * Handle the invalid form submition
   * @param {object[]} errors
   */
  const handleFormInvalid = (errors) => {
    const {
      customerDetails,
      customerPostcode,
      customerContact,
      customerTelephone,
      customerAddressForm,
    } = getCheckoutElements();

    if (errors && errors.length) {
      // Display customer address details form
      customerDetails.classList.add('hide__default');
      customerPostcode.classList.remove('hide__default');
      customerAddressForm.classList.remove('hide__default');
      // Display customer telephone input form
      customerContact.classList.add('hide__default');
      customerTelephone.classList.remove('hide__default');
    }
  };

  /**
   * Handle the customer details on the page and form
   * @param {Object} cDetails The customer details repsonse object
   */
  const customerDetailsHandler = (cDetails) => {
    // Get the checkout input elements
    const {
      postcode,
      address1,
      address2,
      town,
      county,
      telephone,
      editAddressButton,
      addressDropdown,
      editNumberButton,
      findPostcodeButton,
      customerAddress,
      customerNumber,
      customerDetails,
      customerPostcode,
      customerContact,
      customerTelephone,
      customerAddressForm,
    } = getCheckoutElements();

    if (cDetails) {
      const sessionFinanceParams =
        orderDetail !== null
          ? JSON.parse(sessionStorage.getItem(`financeParams${orderDetail.stockRef}`))
          : null;
      const isValidPostcode = POSTCODE_REGX.test(sessionFinanceParams?.deliver2Postcode);

      // Check the order detail object is on the page
      if (sessionFinanceParams?.deliver2Postcode !== '') {
        // IF there is a postcode for the value
        if (isValidPostcode) {
          if (calulatedDeliveryElementsToShow) {
            calulatedDeliveryElementsToShow.forEach((el) => {
              el.classList.remove('hide__default');
            });
          }
          // If the postcode input and session finance params
          setInputValue(postcode, sessionFinanceParams?.deliver2Postcode);
          postcode.classList.add('is-focused');
          postcode.setAttribute('disabled', 'disabled');
          postcode.setAttribute('style', 'cursor: not-allowed;');
        } else {
          setInputValue(town, sessionFinanceParams?.deliver2Postcode);
          setInputValue(address1, '');
          setInputValue(address2, '');
          setInputValue(county, '');
          setInputValue(telephone, cDetails.deliveryTelephone);
          customerPostcode.classList.remove('hide__default');
          customerAddressForm.classList.remove('hide__default');
          customerDetails.classList.add('hide__default');
        }
      } else {
        setInputValue(postcode, cDetails.deliveryPostCode);
        // Set the values to the form inputs
        setInputValue(address1, cDetails.deliveryAddr1);
        setInputValue(address2, cDetails.deliveryAddr2);
        setInputValue(town, cDetails.deliveryAddr3);
        setInputValue(county, cDetails.deliveryAddr4);
        setInputValue(telephone, cDetails.deliveryTelephone);
      }

      // Set the stored details
      customerAddress.textContent = `${
        cDetails.deliveryAddr1 +
        (cDetails.deliveryAddr2 !== '' ? `, ${cDetails.deliveryAddr2}` : '') +
        (cDetails.deliveryAddr3 !== ''
          ? `, ${
              !isValidPostcode && sessionFinanceParams?.deliver2Postcode !== ''
                ? sessionFinanceParams?.deliver2Postcode
                : cDetails.deliveryAddr3
            }`
          : '') +
        (cDetails.deliveryAddr4 !== '' ? `, ${cDetails.deliveryAddr4}` : '')
      }, ${
        sessionFinanceParams?.deliver2Postcode !== '' && isValidPostcode
          ? sessionFinanceParams?.deliver2Postcode
          : cDetails.deliveryPostCode
      }`;

      customerNumber.textContent = cDetails.deliveryTelephone;

      // If the user has not a valid address
      if (
        cDetails.deliveryAddrSts === 'NoValidAddress' ||
        cDetails.deliveryPostCode.replace(/\s/g, '') !== sessionFinanceParams?.deliver2Postcode
      ) {
        // Hide the customer stored details and show the postcode dropdown
        customerDetails.classList.add('hide__default');
        customerPostcode.classList.remove('hide__default');

        // Hide the customer stored contact details and show the telephone input
        customerContact.classList.add('hide__default');
        customerTelephone.classList.remove('hide__default');
      }

      // If the address cannot be edited, hide the edit buttons
      if (cDetails.deliveryAddrEdit !== 'UPDATE') {
        editAddressButton.parentElement.removeChild(editAddressButton);
        editNumberButton.parentElement.removeChild(editNumberButton);
        findPostcodeButton.parentElement.removeChild(findPostcodeButton);
      }
    }

    addressDropdown.addEventListener('change', handleDropdownChangeEvent);
  };

  /**
   * If a postode hs been calulated on the VDP, check the session storage for the
   * dealRef and add the postcode value from the storage to the postcode input
   */
  const setDeliveryPostcode = () => {
    // Get the postcode input on the page
    const { postcode, town } = getCheckoutElements();
    const sessionFinanceParams = JSON.parse(
      sessionStorage.getItem(`financeParams${orderDetail.stockRef}`),
    );
    // Check the order detail object is on the page
    if (orderDetail !== null) {
      if (sessionFinanceParams?.deliver2Postcode !== '') {
        if (POSTCODE_REGX.test(sessionFinanceParams?.deliver2Postcode)) {
          // If the postcode input and session finance params
          setInputValue(postcode, sessionFinanceParams?.deliver2Postcode);
          // postcode.classList.add('is-focused');
          postcode.setAttribute('disabled', 'disabled');
          postcode.setAttribute('style', 'cursor: not-allowed;');
        } else {
          setInputValue(town, sessionFinanceParams?.deliver2Postcode);
        }
      }
    }
  };

  /**
   * Intializes the checkout form and event/input bindings
   */
  const initialize = () => {
    // Check if the checkout was fired from reserve it now
    const isReserveItNowCheckout = /referrer=RESERVE_IT_NOW/i.test(window.location.search);

    if (isReserveItNowCheckout) {
      window.sessionStorage.removeItem(IS_BARCLAYS_CHECKOUT_AND_ECOMM);
    }

    // Change the checkout title if it is reserve it now checkout
    const checkoutTitle = document.querySelector('.js-checkout-heading');
    if (isReserveItNowCheckout && checkoutTitle) {
      checkoutTitle.textContent = '- Pay reservation fee';

      try {
        document.querySelector('.js-money-guarantee').classList.add('hide__default');
        document.querySelector('.js-reserve-it-now').classList.remove('hide__default');
      } catch (err) {
        window.vm.debug.error(err);
      }
    }

    window.SessionCheck.checkSession(AJAX_MBS_URL, 'check').then((res) => {
      const data = res?.myData;

      if (data?.myResultData[0].sessionSts === 'SECURE' && orderDetail !== null) {
        const shouldSubmitOrderForm = window.sessionStorage.getItem(CHECKOUT_KEY);
        const isBarclaysCheckoutAndEcomm = window.sessionStorage.getItem(
          IS_BARCLAYS_CHECKOUT_AND_ECOMM,
        );

        // Check if we should submit the order form
        if (
          ((shouldSubmitOrderForm && shouldSubmitOrderForm === 'true') || isReserveItNowCheckout) &&
          !isBarclaysCheckoutAndEcomm
        ) {
          submitOrderForm();
          window.sessionStorage.removeItem(CHECKOUT_KEY);
        } else {
          // Else get customer details and add form validation
          getCustomerDetails(orderDetail.QuoteId).then((details) => {
            if (details?.deliveryAddress) {
              customerDetailsHandler(details.deliveryAddress);
            }

            // If the user cannot update their address just submit the order form
            if (details?.deliveryAddress?.deliveryAddrEdit !== 'UPDATE') {
              addValidator((event) => {
                event.preventDefault();
                submitOrderForm();
              });
            } else {
              // Else add a handler to update customers details
              addValidator(handleFormSubmit, handleFormInvalid);
            }
          });
        }
      }
    });

    setDeliveryPostcode();
  };

  vm.onload(initialize);
})(window, document);
